import type { CallFees } from '@reservoir0x/relay-sdk'
import type { Logger } from './types'

export interface FunRelayFeeItem {
  b: number
  v: number
}

export async function getFunRelayFees({
  fromTokenAddress,
  fromChainId,
  toTokenAddress,
  toChainId,
  estUsdValue,
  clientId,
}: {
  fromTokenAddress: string
  fromChainId: string
  toTokenAddress: string
  toChainId: string
  estUsdValue: number
  clientId: string
}): Promise<FunRelayFeeItem> {
  const url = `https://frog.fun.xyz/api/fee?fromTokenAddress=${fromTokenAddress}&fromChainId=${fromChainId}&toTokenAddress=${toTokenAddress}&toChainId=${toChainId}&estUsdValue=${estUsdValue}&clientId=${clientId}`
  const response = await fetch(url)
  if (!response.ok) {
    throw Error(response.statusText)
  }

  const data = await response.json()
  return data
}

export function parseRelayFees({
  fees,
  logger,
}: {
  fees: CallFees | undefined
  logger: Logger
}) {
  // Gas fees, denominated in source chain native token
  const relayGasFeesUsd = Number.parseFloat(fees?.gas?.amountUsd || '0')

  // App fees, denominated in source chain token
  const funLpFeesUsd = Number.parseFloat(fees?.app?.amountUsd || '0')
  const funLpFeesFromAmount = Number.parseFloat(
    fees?.app?.amountFormatted || '0',
  )
  const funLpFeesFromAmountBaseUnit = BigInt(fees?.app?.amount || '0')

  // Relay fees, denominated in source chain token
  const relayLpFeesUsd =
    Number.parseFloat(fees?.relayer?.amountUsd || '0') +
    Number.parseFloat(fees?.relayerGas?.amountUsd || '0') +
    Number.parseFloat(fees?.relayerService?.amountUsd || '0')
  const relayLpFeesFromAmount =
    Number.parseFloat(fees?.relayer?.amountFormatted || '0') +
    Number.parseFloat(fees?.relayerGas?.amountFormatted || '0') +
    Number.parseFloat(fees?.relayerService?.amountFormatted || '0')
  const relayLpFeesFromAmountBaseUnit =
    BigInt(fees?.relayer?.amount || '0') +
    BigInt(fees?.relayerGas?.amount || '0') +
    BigInt(fees?.relayerService?.amount || '0')

  const totalLpFeesUsd = funLpFeesUsd + relayLpFeesUsd
  const totalLpFeesFromAmount = funLpFeesFromAmount + relayLpFeesFromAmount
  const totalLpFeesFromAmountBaseUnit =
    funLpFeesFromAmountBaseUnit + relayLpFeesFromAmountBaseUnit

  logger.info('parseRelayFees', {
    relayGasFeesUsd,
    funLpFeesUsd,
    funLpFeesFromAmount,
    funLpFeesFromAmountBaseUnit,
    relayLpFeesUsd,
    relayLpFeesFromAmount,
    relayLpFeesFromAmountBaseUnit,
    totalLpFeesUsd,
    totalLpFeesFromAmount,
    totalLpFeesFromAmountBaseUnit,
  })

  return {
    relayGasFeesUsd,
    totalLpFeesUsd,
    totalFeesUsd: relayGasFeesUsd + totalLpFeesUsd,
    totalFeesFromAmount: totalLpFeesFromAmount,
    totalFeesFromAmountBaseUnit: totalLpFeesFromAmountBaseUnit,
  }
}
